import { Box, Grid, styled } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Icon } from "../../components/icon/Icon";
import { dispatcher } from "../../store";

const FullScreenBox = styled(Box)((p) => ({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

export const BackendUnavailable = () => {
  const [ counter, setCounter ] = useState<number>(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter(prevCounter => prevCounter > 0 ? prevCounter - 1 : 5);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (counter === 0) {
      dispatcher.system.setBackendOnline(true);
    }
  }, [counter]);

  return (
    <FullScreenBox>
      <h1 style={{fontSize: '3rem'}}>Unable to Reach Server</h1>
      <h3 style={{fontSize: '1.5rem'}} margin-top="0">Trying again in {counter} seconds...</h3>
      <div style={{ padding: 20 }}>
        <Grid container justify="center" alignItems="center" spacing={1}>
          <Grid item>
            <Icon icon="faServer" size="10x" />
          </Grid>
          <Grid item>
            <Icon icon="faExclamationCircle" size="8x" />
          </Grid>
        </Grid>
      </div>
    </FullScreenBox>
  )
}